import { ProblemProgress } from '@yandex-int/k-common/typings';
import React from 'react';

const RADIUS = 32;

interface OwnProps {
    mix?: string;
    stats: ProblemProgress;
}

interface Props extends OwnProps {}

const StatsProgressChart = ({ mix, stats }: Props) => {
    const { fail, success, unknown } = stats;
    const total = fail + success + unknown;

    const circumferenceLength = 2 * Math.PI * RADIUS;
    const calcSectorPercent = (value: number): number => (circumferenceLength * value) / total;

    const failSectorPercent = calcSectorPercent(fail);
    const successSectorPercent = calcSectorPercent(success) + failSectorPercent;

    return (
        <svg className={mix} fill="none" height="80" viewBox="0 0 80 80" width="80" xmlns="http://www.w3.org/2000/svg">
            <circle
                className="stats__stats-progress-chart_unknown"
                cx="40"
                cy="40"
                fill="none"
                r="32"
                stroke="#ebebeb"
                strokeWidth="16"
            />
            {successSectorPercent && (
                <circle
                    className="stats__stats-progress-chart_success"
                    cx="40"
                    cy="40"
                    fill="none"
                    r="32"
                    stroke="#27ae60"
                    strokeDasharray={`${successSectorPercent},${circumferenceLength}`}
                    strokeWidth="16"
                    transform="rotate(-90 40 40)"
                />
            )}
            {failSectorPercent && (
                <circle
                    className="stats__stats-progress-chart_fail"
                    cx="40"
                    cy="40"
                    fill="none"
                    r="32"
                    stroke="#ec8383"
                    strokeDasharray={`${failSectorPercent},${circumferenceLength}`}
                    strokeWidth="16"
                    transform="rotate(-90 40 40)"
                />
            )}
        </svg>
    );
};

export default StatsProgressChart;
